exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "hr{border-bottom:1px solid #000}.slide{padding-bottom:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4c2dd986!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Slide.vue
// module id = 16
// module chunks = 0